module.exports = __webpack_public_path__ + "img/ribbon_red.02203328.png";